import { useEffect } from 'react'

import { isFunction } from '@/utils/helpers/typeChecking'

const useEventListener = ({ eventName, eventHandle, element = window }) => {
  useEffect(() => {
    if (!element?.addEventListener) return
    if (eventName && isFunction(eventHandle)) {
      element?.addEventListener(eventName, eventHandle)

      return () => {
        element?.removeEventListener(eventName, eventHandle)
      }
    }
  }, [eventName, eventHandle, element])
}

export default useEventListener
